import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/index'

/* 引入Router Modules中的路由 */
import homeCareRouter from './modules/homecare'
import mechanismRouter from './modules/mechanism'
import aboutRouter from './modules/about'
import publicWelfareRouter from './modules/publicwelfare'
import seniorClassRouter from './modules/seniorclass'
import joinRouter from './modules/join'
import memberRouter from './modules/member'
import newsRouter from './modules/news'
import attentionRouter from './modules/attention'
import agreementRouter from './modules/agreement'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: Layout,
      redirect: '/login/index',
      children: [
        {
          path: 'index',
          name: 'login',
          component: () => import('../views/login/index')
        }
      ]
    },
    {
      path: '/register',
      component: Layout,
      redirect: '/register/index',
      children: [
        {
          path: 'index',
          name: 'register',
          component: () => import('../views/login/register')
        }
      ]
    },
    {
      path: '/forget',
      component: Layout,
      redirect: '/forget/index',
      children: [
        {
          path: 'index',
          name: 'forget',
          component: () => import('../views/login/forget')
        }
      ]
    },
    {
      path: '/success',
      component: Layout,
      redirect: '/success/index',
      children: [
        {
          path: 'index',
          name: 'success',
          component: () => import('../views/login/success')
        },
        {
          path: 'index2',
          name: 'success2',
          component: () => import('../views/login/success2')
        }
      ]
    },
    {
      path: '/',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('../views/home/index')
        }
      ]
    },
    homeCareRouter,
    mechanismRouter,
    aboutRouter,
    publicWelfareRouter,
    seniorClassRouter,
    joinRouter,
    memberRouter,
    newsRouter,
    attentionRouter,
    agreementRouter
  ]
})
